import axios from "axios";


const fetchExposures = async (exposureNames, onError, token) => {
  try{
    const config = token ? { headers: { Authorization: `Bearer ${token}` } } : undefined;
    const data = await axios.post('/api/referentiel/exposure/details', {
      exposures: exposureNames
    }, config);

    if (data.status === 200) {
      return data.data;
    }
    console.error("Erreur lors de la récupération des données des expositions");
    onError(data);
  }
  catch(error) {
    if(error.response && error.response.data.message){
      console.error("Erreur : " + error.response.data.message);
    }
    onError(error);
  }
};


const fetchJobs = async (shortId, onError, token) => {
  try{
    const config = {
      headers: { Authorization: `Bearer ${token}` },
      params: { shortId }
    };
    const data = await axios.get('/api/referentiel/job/favorite/list', config);

    if (data.status === 200) {
      return data.data;
    }
    console.error("Erreur lors de la récupération des données des métiers");
    onError(data);
  }
  catch(error) {
    if(error.response && error.response.data.message){
      console.error("Erreur : " + error.response.data.message);
    }
    onError(error);
  }
};

const fetchPublicJobs = async (onError, shortId, tokenForLimitedAccess) => {
  try{
    const data = await axios.get('/api/referentiel/job/list', { params: { shortId, tokenForLimitedAccess } });

    if (data.status === 200) {
      return data.data;
    }
    console.error("Erreur lors de la récupération des données des métiers");
    onError(data);
  }
  catch(error) {
    if(error.response && error.response.data.message){
      console.error("Erreur : " + error.response.data.message);
    }
    onError(error);
  }
};

// Récupère la liste publique des métiers (source Presanse uniquement) pour le test
// d'éligibilité VFC — parcours 100% anonyme, sans token de visite. Le filtrage par saisie se fait
// côté client.
const ELIGIBILITY_JOBS_CACHE_KEY = 'eligibilityJobs';
const ELIGIBILITY_JOBS_TTL_MS = 24 * 60 * 60 * 1000; // 24h
let eligibilityJobsMemoryCache = null;

const fetchEligibilityJobs = async (onError) => {
  // 1. Cache mémoire (même session SPA)
  if (eligibilityJobsMemoryCache) return eligibilityJobsMemoryCache;

  // 2. Cache localStorage (sessions suivantes, avec TTL)
  try {
    const cached = JSON.parse(localStorage.getItem(ELIGIBILITY_JOBS_CACHE_KEY));
    if (cached && Array.isArray(cached.jobs) && (Date.now() - cached.timestamp) < ELIGIBILITY_JOBS_TTL_MS) {
      eligibilityJobsMemoryCache = cached.jobs;
      return cached.jobs;
    }
  } catch { /* localStorage indisponible ou corrompu : on recharge */ }

  // 3. Récupération réseau
  try{
    const data = await axios.get('/api/referentiel/job/search');

    if (data.status === 200) {
      eligibilityJobsMemoryCache = data.data;
      try {
        localStorage.setItem(ELIGIBILITY_JOBS_CACHE_KEY, JSON.stringify({ jobs: data.data, timestamp: Date.now() }));
      } catch { /* quota / mode privé : le cache mémoire suffit */ }
      return data.data;
    }
    console.error("Erreur lors de la récupération de la liste des métiers");
    if (onError) onError(data);
  }
  catch(error) {
    if(error.response && error.response.data.message){
      console.error("Erreur : " + error.response.data.message);
    }
    if (onError) onError(error);
  }
};

const fetchCodesNAF = async (onError) => {
  try{
    const data = await axios.get('/api/referentiel/naf/list');

    if (data.status === 200) {
      return data.data;
    }
    console.error("Erreur lors de la récupération des données des codes NAF");
    onError(data);
  }
  catch(error) {
    if(error.response && error.response.data.message){
      console.error("Erreur : " + error.response.data.message);
    }
    onError(error);
  }
};

const fetchJobMEEPsMETAPsInfos = async (jobName, token, onError) => {
  try{
    const config = token ? {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    } : {};

    const data = await axios.post('/api/referentiel/job/meeps-metaps-infos', {
      jobName: jobName,
    }, config);
    
    if (data.status === 200) {
      return data.data;
    }
    // Sinon on appel le callback d'erreur
    console.error("Erreur lors de la récupération des données des taches et des expositions potentielles");
    onError(data);
  }
  catch(error) {
    console.error("Erreur lors de la récupération des données");
    onError(error);
  }
};

const fetchPathologicalCenters = async (token, onError) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try{
    const data = await axios.get('/api/referentiel/pathologicalCenters', config);
    
    if (data.status === 200) {
      return data.data;
    }
    // Sinon on appel le callback d'erreur
    console.error("Erreur lors de la récupération des données des centres de pathologie professionnelle");
    onError(data);
  }
  catch(error) {
    if(error.response && error.response.data.message){
      console.error("Erreur : " + error.response.data.message);
    }
    console.error("Erreur lors de la récupération des données des centres de pathologie professionnelle");
    onError(error);
  }
};

const fetchFollowUpList = async (token, onError) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try{
    const data = await axios.get('/api/referentiel/followUpList', config);
    
    if (data.status === 200) {
      return data.data;
    }
    // Sinon on appel le callback d'erreur
    console.error("Erreur lors de la récupération des données des liste de suivi");
    onError(data);
  }
  catch(error) {
    if(error.response && error.response.data.message){
      console.error("Erreur : " + error.response.data.message);
    }
    console.error("Erreur lors de la récupération des données des liste de suivi");
    onError(error);
  }
};

const fetchExposureTreedata = async (onError) => {
  try{
    const data = await axios.get('/api/referentiel/exposure/treedata');
    
    if (data.status === 200) {
      return data.data;
    }
    // Sinon on appel le callback d'erreur
    console.error("Erreur lors de la récupération de l'arbre des expositions");
    onError(data);
  }
  catch(error) {
    if(error.response && error.response.data.message){
      console.error("Erreur : " + error.response.data.message);
    }
    console.error("Erreur lors de la récupération de l'arbre des expositions");
    onError(error);
  }
};

const fetchCoExposuresdata = async (onError) => {
  try{
    const data = await axios.get('/api/referentiel/exposure/coExposuresData');
    
    if (data.status === 200) {
      return data.data;
    }
    // Sinon on appel le callback d'erreur
    console.error("Erreur lors de la récupération de l'arbre des co-expositions");
    onError(data);
  }
  catch(error) {
    if(error.response && error.response.data.message){
      console.error("Erreur : " + error.response.data.message);
    }
    console.error("Erreur lors de la récupération de l'arbre des co-expositions");
    onError(error);
  }
};

const fetchMandatoryExposures = async (token, onError) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try{
    const data = await axios.get('/api/referentiel/exposure/mandatory', config);
    
    if (data.status === 200) {
      return data.data;
    }
    // Sinon on appel le callback d'erreur
    console.error("Erreur lors de la récupération des expositions à dépister obligatoires");
    onError(data);
  }
  catch(error) {
    if(error.response && error.response.data.message){
      console.error("Erreur : " + error.response.data.message);
    }
    console.error("Erreur lors de la récupération des expositions à dépister obligatoires");
    onError(error);
  }
};

const fetchTaskExposures = async (tasks, token, onError) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try{
    const data = await axios.post('/api/referentiel/task/exposures', {
      tasks: tasks
    }, config);

    if (data.status === 200) {
      return data.data;
    }
    // Sinon on appel le callback d'erreur
    console.error("Erreur lors de la récupération de la matrice taches/expositions ");
    onError(data);
  }
  catch(error) {
    if(error.response && error.response.data.message){
      console.error("Erreur : " + error.response.data.message);
    }
    console.error("Erreur lors de la récupération de la matrice taches/expositions ");
    onError(error);
  }
};

const fetchExposureTasks = async (expositions, token, onError) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try{
    const data = await axios.post('/api/referentiel//exposure/tasks', {
      exposures: expositions
    }, config);

    if (data.status === 200) {
      return data.data;
    }
    // Sinon on appel le callback d'erreur
    console.error("Erreur lors de la récupération de la matrice taches/expositions ");
    onError(data);
  }
  catch(error) {
    if(error.response && error.response.data.message){
      console.error("Erreur : " + error.response.data.message);
    }
    console.error("Erreur lors de la récupération de la matrice taches/expositions ");
    onError(error);
  }
};

const addJobFavorite = async (job, unmodifiedJobName, tasks, exposures, visibilite, visibiliteExpoTache, type, onError, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try{
    const data = await axios.post('/api/referentiel/favorite', {
      job,
      unmodifiedJobName,
      tasks,
      exposures,
      visibilite,
      visibiliteExpoTache,
      type,
    }, config);

    if (data.status === 200) {
      return data.data;
    }
    // Sinon on appel le callback d'erreur
    console.error("Erreur lors de la mise à jour des favoris");
    onError(data);
  }
  catch(error) {
    if(error.response && error.response.data.message){
      console.error("Erreur : " + error.response.data.message);
    }
    console.error("Erreur lors de la mise à jour des favoris");
    onError(error);
  }
};

const deleteTaskOrExpoFavorite = async (job, tasks, exposures, onError, token) => {
  try{
    const data = await axios.delete('/api/referentiel/favorite', {
      data: {
        job: job,
        tasks: tasks,
        exposures: exposures,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      }
    });

    if (data.status === 200) {
      return data.data;
    }
    // Sinon on appel le callback d'erreur
    console.error("Erreur lors de la mise à jour des favoris");
    onError(data);
  }
  catch(error) {
    if(error.response && error.response.data.message){
      console.error("Erreur : " + error.response.data.message);
    }
    console.error("Erreur lors de la mise à jour des favoris");
    onError(error);
  }
};

const createJobTask = async (jobId, task, exposures, visibility, unmodifiedJobName, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const data = await axios.put('/api/referentiel/task/create', {
    jobId: jobId,
    task: task,
    exposures: exposures,
    visibility,
    unmodifiedJobName
  }, config);

  if (data.status === 200) {
    return data.data;
  }
  throw Error("Erreur lors de la creation de tâche");

};

const fetchAutocompleteTasks = async (searchTerm, token) => {
  try{
    const data = await axios.get('/api/referentiel/task/autocomplete', {
      params: {
        q: searchTerm,
        limit: 15
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (data.status === 200) {
      return data.data;
    }
  }
  catch(error) {
    if(error.response && error.response.data.message){
      console.error("Erreur : " + error.response.data.message);
    }
    console.error("Erreur lors de la récupération des tâches pour autocomplete");
  }
};

const createCustomJob = async (jobName, jobOrigineId, visibility, isCopyTaskFavorites, isCopyExpoFavorites, onError, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try{
    const data = await axios.post('/api/referentiel/job/custom/create', {
      job: jobName,
      jobOrigine: jobOrigineId,
      visibility,
      isCopyTaskFavorites,
      isCopyExpoFavorites,
    }, config);

    if (data.status === 200) {
      return data.data;
    }
    // Sinon on appel le callback d'erreur
    onError(data);
    console.error("Erreur lors de la création du métier ");
  }
  catch(error) {
    if(error.response && error.response.data.message){
      console.error("Erreur : " + error.response.data.message);
    }
    onError(error);
    console.error("Erreur lors de la création du métier ");
  }
};

const createCustomJobPublic = async (jobName, jobOrigineId, shortId, tokenForLimitedAccess, onError) => {
  try{
    const data = await axios.post('/api/referentiel/job/custom/public/create', {
      job: jobName,
      jobOrigine: jobOrigineId,
      shortId,
      tokenForLimitedAccess,
    });

    if (data.status === 200) {
      return data.data;
    }
    // Sinon on appel le callback d'erreur
    onError(data);
    console.error("Erreur lors de la création du métier ");
  }
  catch(error) {
    if(error.response && error.response.data.message){
      console.error("Erreur : " + error.response.data.message);
    }
    onError(error);
    console.error("Erreur lors de la création du métier ");
  }
};

const deleteCustomJob = async (jobId, onError, token) => {
  try{
    const data = await axios.delete('/api/referentiel/job/custom/delete', {
      data: {
        job: jobId,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      }
    });

    if (data.status === 200) {
      return data.data;
    }
    // Sinon on appel le callback d'erreur
    onError(data);
    console.error("Erreur lors de la suppression du métier ");
  }
  catch(error) {
    if(error.response && error.response.data.message){
      console.error("Erreur : " + error.response.data.message);
    }
    onError(error);
    console.error("Erreur lors de la suppression du métier ");
  }
};

const fetchJobsFavoriteDetails = async (jobs, onError, token) => {
  try{
    const config = { headers: { Authorization: `Bearer ${token}` } };
    const data = await axios.post('/api/referentiel/job/favorite/details', {jobs}, config);

    if (data.status === 200) {
      return data.data;
    }
    console.error("Erreur lors de la récupération des données des métiers");
    onError(data);
  }
  catch(error) {
    if(error.response && error.response.data.message){
      console.error("Erreur : " + error.response.data.message);
    }
    onError(error);
  }
};

const fetchJobFavoriteTasks = async (job, onError, token) => {
  try{
    const config = { headers: { Authorization: `Bearer ${token}` } };
    const data = await axios.post('/api/referentiel/job/favorite/tasks', {job}, config);

    if (data.status === 200) {
      return data.data;
    }
    console.error("Erreur lors de la récupération des données des métiers");
    onError(data);
  }
  catch(error) {
    if(error.response && error.response.data.message){
      console.error("Erreur : " + error.response.data.message);
    }
    onError(error);
  }
};

const fetchJobFavoriteExpositions = async (job, onError, token) => {
  try{
    const config = { headers: { Authorization: `Bearer ${token}` } };
    const data = await axios.post('/api/referentiel/job/favorite/exposures', {job}, config);

    if (data.status === 200) {
      return data.data;
    }
    console.error("Erreur lors de la récupération des données des métiers");
    onError(data);
  }
  catch(error) {
    if(error.response && error.response.data.message){
      console.error("Erreur : " + error.response.data.message);
    }
    onError(error);
  }
};

const addJobToFavorites = async (job, visibility, unmodifiedJobName, onError, token) => {
  try {
    const config = { headers: { Authorization: `Bearer ${token}` } };
    const data = await axios.post('/api/referentiel/job/favorite', {
      job, visibility, unmodifiedJobName
    }, config);

    if (data.status === 200) {
      return data.data;
    }
    console.error("Erreur lors de la création du favori");
    onError(data);
  }
  catch(error) {
    if(error.response && error.response.data.message){
      console.error("Erreur : " + error.response.data.message);
    }
    onError(error);
  }
};


const changeJobOrigine = async (job, origine, isCopyTaskFavorites, isCopyExpoFavorites, onError, token) => {
  try {
    const config = { headers: { Authorization: `Bearer ${token}` } };
    const data = await axios.post('/api/referentiel/job/changeorigine', {job, origine, isCopyTaskFavorites, isCopyExpoFavorites}, config);

    if (data.status === 200) {
      return data.data;
    }
    console.error("Erreur lors du changement d'origine");
    onError(data);
  }
  catch(error) {
    if(error.response && error.response.data.message){
      console.error("Erreur : " + error.response.data.message);
    }
    onError(error);
  }
};

const masquerDemasquerTaches = async (job, tasks, masquer, onError, token) => {
  try{
    const config = { headers: { Authorization: `Bearer ${token}` } };
    const data = await axios.post('/api/referentiel/job/task/masquer', {job, tasks, masquer}, config);

    if (data.status === 200) {
      return data.data;
    }
    console.error("Erreur lors de la récupération des données des métiers");
    onError(data);
  }
  catch(error) {
    if(error.response && error.response.data.message){
      console.error("Erreur : " + error.response.data.message);
    }
    onError(error);
  }
};

const masquerDemasquerExpositions = async (job, exposures, masquer, onError, token) => {
  try{
    const config = { headers: { Authorization: `Bearer ${token}` } };
    const data = await axios.post('/api/referentiel/job/exposure/masquer', {job, exposures, masquer}, config);

    if (data.status === 200) {
      return data.data;
    }
    console.error("Erreur lors de la récupération des données des métiers");
    onError(data);
  }
  catch(error) {
    if(error.response && error.response.data.message){
      console.error("Erreur : " + error.response.data.message);
    }
    onError(error);
  }
};

const fetchJobTasks = async (jobId, onError, token) => {
  try{
    const config = { headers: { Authorization: `Bearer ${token}` } };
    const data = await axios.post('/api/referentiel/job/tasks', {jobId}, config);

    if (data.status === 200) {
      return data.data;
    }
    console.error("Erreur lors de la récupération des tâches du métier");
    onError(data);
  }
  catch(error) {
    if(error.response && error.response.data.message){
      console.error("Erreur : " + error.response.data.message);
    }
    onError(error);
  }
};

const fetchJobExposures = async (jobId, onError, token) => {
  try{
    const config = { headers: { Authorization: `Bearer ${token}` } };
    const data = await axios.post('/api/referentiel/job/exposures', {jobId}, config);

    if (data.status === 200) {
      return data.data;
    }
    console.error("Erreur lors de la récupération des expositions du métier");
    onError(data);
  }
  catch(error) {
    if(error.response && error.response.data.message){
      console.error("Erreur : " + error.response.data.message);
    }
    onError(error);
  }
};

const importJobTasks = async (jobId, tasks, onError, token) => {
  try{
    const config = { headers: { Authorization: `Bearer ${token}` } };
    const data = await axios.post('/api/referentiel/job/import/tasks', {jobId, tasks}, config);

    if (data.status === 200) {
      return data.data;
    }
    console.error("Erreur lors de l'import des tâches");
    onError(data);
  }
  catch(error) {
    if(error.response && error.response.data.message){
      console.error("Erreur : " + error.response.data.message);
    }
    onError(error);
  }
};

const importJobExposures = async (jobId, expos, onError, token) => {
  try{
    const config = { headers: { Authorization: `Bearer ${token}` } };
    const data = await axios.post('/api/referentiel/job/import/exposures', {jobId, expos}, config);

    if (data.status === 200) {
      return data.data;
    }
    console.error("Erreur lors de l'import des expositions");
    onError(data);
  }
  catch(error) {
    if(error.response && error.response.data.message){
      console.error("Erreur : " + error.response.data.message);
    }
    onError(error);
  }
};

const fetchRecentConseils = async (token, onError) => {
  try{
    const config = token ? { headers: { Authorization: `Bearer ${token}` } } : undefined;
    const data = await axios.get('/api/referentiel/conseil/recent', config);

    if (data.status === 200) {
      return data.data;
    }
    console.error("Erreur lors de la récupération des conseils récemment retenus");
    onError && onError(data);
  }
  catch(error) {
    if(error.response && error.response.data.message){
      console.error("Erreur : " + error.response.data.message);
    }
    onError && onError(error);
  }
};

const saveConseilSelections = async (offered, selected, token, onError) => {
  try{
    const config = token ? { headers: { Authorization: `Bearer ${token}` } } : undefined;
    const data = await axios.post('/api/referentiel/conseil/stats', { offered, selected }, config);

    if (data.status === 204 || data.status === 200) {
      return data.data;
    }
    console.error("Erreur lors de l'enregistrement des conseils retenus");
    onError && onError(data);
  }
  catch(error) {
    if(error.response && error.response.data.message){
      console.error("Erreur : " + error.response.data.message);
    }
    onError && onError(error);
  }
};

// Catalogue complet des conseils (N1 -> enfants N2) pour construire l'arbre des sélections favorites
const fetchAllConseils = async (token, onError) => {
  try{
    const config = token ? { headers: { Authorization: `Bearer ${token}` } } : undefined;
    const data = await axios.get('/api/referentiel/conseil/all', config);

    if (data.status === 200) {
      return data.data;
    }
    console.error("Erreur lors de la récupération du catalogue de conseils");
    onError && onError(data);
  }
  catch(error) {
    if(error.response && error.response.data.message){
      console.error("Erreur : " + error.response.data.message);
    }
    onError && onError(error);
  }
};

// Sélections favorites de conseils de l'utilisateur courant
const fetchConseilSelections = async (token, onError) => {
  try{
    const config = token ? { headers: { Authorization: `Bearer ${token}` } } : undefined;
    const data = await axios.get('/api/referentiel/conseil/selections', config);

    if (data.status === 200) {
      return data.data;
    }
    console.error("Erreur lors de la récupération des sélections favorites de conseils");
    onError && onError(data);
  }
  catch(error) {
    if(error.response && error.response.data.message){
      console.error("Erreur : " + error.response.data.message);
    }
    onError && onError(error);
  }
};

const createConseilSelection = async (selection, token, onError) => {
  try{
    const config = token ? { headers: { Authorization: `Bearer ${token}` } } : undefined;
    const data = await axios.post('/api/referentiel/conseil/selections', selection, config);

    if (data.status === 201 || data.status === 200) {
      return data.data;
    }
    console.error("Erreur lors de la création de la sélection favorite");
    onError && onError(data);
  }
  catch(error) {
    if(error.response && error.response.data.message){
      console.error("Erreur : " + error.response.data.message);
    }
    onError && onError(error);
  }
};

const updateConseilSelection = async (id, selection, token, onError) => {
  try{
    const config = token ? { headers: { Authorization: `Bearer ${token}` } } : undefined;
    const data = await axios.put(`/api/referentiel/conseil/selections/${id}`, selection, config);

    if (data.status === 200) {
      return data.data;
    }
    console.error("Erreur lors de la mise à jour de la sélection favorite");
    onError && onError(data);
  }
  catch(error) {
    if(error.response && error.response.data.message){
      console.error("Erreur : " + error.response.data.message);
    }
    onError && onError(error);
  }
};

const deleteConseilSelection = async (id, token, onError) => {
  try{
    const config = token ? { headers: { Authorization: `Bearer ${token}` } } : undefined;
    const data = await axios.delete(`/api/referentiel/conseil/selections/${id}`, config);

    if (data.status === 204 || data.status === 200) {
      return true;
    }
    console.error("Erreur lors de la suppression de la sélection favorite");
    onError && onError(data);
  }
  catch(error) {
    if(error.response && error.response.data.message){
      console.error("Erreur : " + error.response.data.message);
    }
    onError && onError(error);
  }
};

// Conseils personnalisés : création (privé par défaut, ligne miroir SST si visibility.sst)
const createConseilCustom = async (conseil, token, onError) => {
  try{
    const config = token ? { headers: { Authorization: `Bearer ${token}` } } : undefined;
    const data = await axios.post('/api/referentiel/conseil/custom', conseil, config);

    if (data.status === 201 || data.status === 200) {
      return data.data;
    }
    console.error("Erreur lors de la création du conseil personnalisé");
    onError && onError(data);
  }
  catch(error) {
    if(error.response && error.response.data.message){
      console.error("Erreur : " + error.response.data.message);
    }
    onError && onError(error);
  }
};

const updateConseilCustom = async (id, conseil, token, onError) => {
  try{
    const config = token ? { headers: { Authorization: `Bearer ${token}` } } : undefined;
    const data = await axios.put(`/api/referentiel/conseil/custom/${id}`, conseil, config);

    if (data.status === 200) {
      return data.data;
    }
    console.error("Erreur lors de la mise à jour du conseil personnalisé");
    onError && onError(data);
  }
  catch(error) {
    if(error.response && error.response.data.message){
      console.error("Erreur : " + error.response.data.message);
    }
    onError && onError(error);
  }
};

const deleteConseilCustom = async (id, token, onError) => {
  try{
    const config = token ? { headers: { Authorization: `Bearer ${token}` } } : undefined;
    const data = await axios.delete(`/api/referentiel/conseil/custom/${id}`, config);

    if (data.status === 204 || data.status === 200) {
      return true;
    }
    console.error("Erreur lors de la suppression du conseil personnalisé");
    onError && onError(data);
  }
  catch(error) {
    if(error.response && error.response.data.message){
      console.error("Erreur : " + error.response.data.message);
    }
    onError && onError(error);
  }
};

export { fetchJobs, fetchPublicJobs, fetchEligibilityJobs, fetchJobsFavoriteDetails, fetchCodesNAF, fetchJobMEEPsMETAPsInfos, fetchExposures, fetchPathologicalCenters, fetchFollowUpList, fetchExposureTreedata,
  fetchCoExposuresdata, fetchTaskExposures, fetchMandatoryExposures, addJobFavorite, deleteTaskOrExpoFavorite, createJobTask, changeJobOrigine, masquerDemasquerTaches, masquerDemasquerExpositions,
  fetchAutocompleteTasks, createCustomJob, createCustomJobPublic, deleteCustomJob, fetchJobFavoriteTasks, fetchJobFavoriteExpositions, addJobToFavorites, fetchExposureTasks, fetchJobTasks, fetchJobExposures, importJobTasks, importJobExposures,
  fetchRecentConseils, saveConseilSelections,
  fetchAllConseils, fetchConseilSelections, createConseilSelection, updateConseilSelection, deleteConseilSelection,
  createConseilCustom, updateConseilCustom, deleteConseilCustom };
